module.exports = __webpack_public_path__ + "static/media/dashboard.298dd401.svg";